import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("helix_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("helix_token"))
      .finally(() => setLoading(false));
  }, []);

  const loginWithToken = async (token) => {
    localStorage.setItem("helix_token", token);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      localStorage.removeItem("helix_token");
      throw e;
    }
  };
  const exchangeHandoff = async () => {
    const { data } = await api.post("/auth/exchange", {}, { withCredentials: true });
    localStorage.setItem("helix_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* best effort */ }
    localStorage.removeItem("helix_token");
    setUser(null);
  };
  return <AuthCtx.Provider value={{ user, setUser, loading, loginWithToken, exchangeHandoff, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

// Where to land a user after login, based on their access.
export const homePathFor = (user) => {
  if (!user) return "/login";
  if (["soc_analyst", "soc_lead", "soc_auditor", "soc_viewer"].includes(user.role)) return "/soc";
  if (user.role === "timesheet_admin") return "/reports";
  if (["admin", "manager", "agent"].includes(user.role)) return "/";
  if (user.timesheet_access || user.timesheet_role) return "/timesheet";
  return "/portal";
};
